module.exports = __webpack_public_path__ + "static/media/vf_wjumper_core.1c3c8c16.svg";